/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { string } from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const AnimatedCheck = (props) => {
    const { className } = props;
    return (
        <SvgIcon className={className} viewBox="10 20 115 95">
            <path
                className="checkmark animated"
                d="M24.75 62l27.5 27.5 51-51"
            />
        </SvgIcon>
    );
};

AnimatedCheck.defaultProps = { className: '' };

AnimatedCheck.propTypes = { className: string };

export default AnimatedCheck;
